export default __webpack_public_path__ + "static/media/spotify.dd117df1.svg";